"use client"

import { useFormStatus } from "react-dom"

/** server action 폼 전용 제출 버튼 — pending 중 disabled + 스피너 + 라벨 교체. */
export function SubmitButton({
  children,
  pendingLabel,
  className = "btn",
  disabled: disabledProp,
  "aria-label": ariaLabel,
}: {
  children: React.ReactNode
  pendingLabel?: string
  className?: string
  disabled?: boolean
  "aria-label"?: string
}) {
  const { pending } = useFormStatus()
  const disabled = pending || disabledProp
  return (
    <button type="submit" className={className} disabled={disabled} aria-busy={pending} aria-label={ariaLabel}>
      {pending && <span className="spinner" aria-hidden />}
      {pending ? (pendingLabel ?? children) : children}
    </button>
  )
}
